"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemConfigEditor = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Text_1 = require("office-ui-fabric-react/lib/Text");
var ai_hub_settings_utils_1 = require("../utils/ai-hub-settings-utils");
var RecordEntryRow_1 = require("./RecordEntryRow");
/**
 * Editor for a system's connection config (key/value pairs). Rendered inline
 * below the system table row when the system is being edited.
 */
exports.SystemConfigEditor = function (props) {
    var system = props.system, isEntryKeyChanged = props.isEntryKeyChanged, isEntryValueChanged = props.isEntryValueChanged, onConfigChange = props.onConfigChange;
    var configEntries = Object.entries(system.config || {});
    return (react_1.default.createElement("div", { className: "ws-ai-hub-settings-panel-section" },
        react_1.default.createElement("div", { className: "ws-ai-hub-settings-toolbar" },
            react_1.default.createElement(Text_1.Text, { className: "ws-ai-hub-settings-panel-section-title" }, "Connection config"),
            react_1.default.createElement(Button_1.DefaultButton, { className: "ws-admin-button-add ws-admin-button-hover-accent", text: "Add Config Entry", onClick: function () {
                    return onConfigChange(ai_hub_settings_utils_1.appendRecordEntry(system.config, "configKey"));
                } })),
        configEntries.length === 0 && (react_1.default.createElement(Text_1.Text, { className: "ws-ai-hub-settings-card-subtitle", variant: "small" }, "No connection config entries defined.")),
        configEntries.map(function (_a, entryIndex) {
            var entryKey = _a[0], entryValue = _a[1];
            return (react_1.default.createElement(RecordEntryRow_1.RecordEntryRow, { key: entryKey + entryIndex, entryKey: entryKey, entryValue: entryValue, entryIndex: entryIndex, keyLabel: "Connection config: key", valueLabel: "Value", keyPlaceholder: "Key", valuePlaceholder: "Value", keyAriaLabel: "Connection config key", valueAriaLabel: "Connection config value", isKeyChanged: isEntryKeyChanged(entryIndex), isValueChanged: isEntryValueChanged(entryIndex), removeButtonTitle: "Remove config entry", removeButtonAriaLabel: "Remove config entry", onKeyChange: function (nextKey) {
                    return onConfigChange(ai_hub_settings_utils_1.updateRecordEntry(system.config, entryIndex, nextKey, entryValue));
                }, onValueChange: function (nextValue) {
                    return onConfigChange(ai_hub_settings_utils_1.updateRecordEntry(system.config, entryIndex, entryKey, nextValue));
                }, onRemove: function () {
                    return onConfigChange(ai_hub_settings_utils_1.removeRecordEntry(system.config, entryIndex));
                } }));
        })));
};
